/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function() {
  function getVisibleThumbnails(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumbnail')).filter(function(thumbnail) {
      return !thumbnail.classList.contains('is-filtered');
    });
  }

  function goToGalleryImage(gallery, direction) {
    var thumbnails = getVisibleThumbnails(gallery);

    if (!thumbnails.length) {
      return;
    }

    var currentIndex = thumbnails.findIndex(function(thumbnail) {
      return thumbnail.classList.contains('is-nav-selected');
    });

    if (currentIndex === -1) {
      currentIndex = 0;
    }

    var nextIndex = currentIndex + direction;

    if (nextIndex < 0) {
      nextIndex = thumbnails.length - 1;
    }

    if (nextIndex >= thumbnails.length) {
      nextIndex = 0;
    }

    thumbnails[nextIndex].click();
  }

  document.addEventListener('click', function(event) {
    var prevButton = event.target.closest('.cro-gallery-arrow--prev');
    var nextButton = event.target.closest('.cro-gallery-arrow--next');

    if (!prevButton && !nextButton) {
      return;
    }

    event.preventDefault();

    var gallery = event.target.closest('.product-gallery');

    if (!gallery) {
      return;
    }

    goToGalleryImage(gallery, prevButton ? -1 : 1);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    var gallery = document.querySelector('.product-gallery');

    if (!gallery) {
      return;
    }

    var galleryRect = gallery.getBoundingClientRect();
    var galleryIsVisible = galleryRect.top < window.innerHeight && galleryRect.bottom > 0;

    if (!galleryIsVisible) {
      return;
    }

    goToGalleryImage(gallery, event.key === 'ArrowLeft' ? -1 : 1);
  });
})();
/* CRO: PDP description Read More — verified for Fat Buddha Glass product markup */
(function () {
  var DESCRIPTION_SELECTOR = '.product-block-list__item--description .card__section .rte';
  var SPLIT_HEADINGS = [
    'key features',
    'features',
    'why you’ll love it',
    "why you'll love it",
    'specifications',
    'includes',
    'care tips'
  ];

  function normalizeText(text) {
    return (text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isSplitHeading(node) {
    if (!node || !/^H[2-4]$/.test(node.tagName)) {
      return false;
    }

    var headingText = normalizeText(node.textContent);

    for (var i = 0; i < SPLIT_HEADINGS.length; i++) {
      if (headingText.indexOf(SPLIT_HEADINGS[i]) !== -1) {
        return true;
      }
    }

    return false;
  }

  function findSplitNode(description) {
    var children = Array.prototype.slice.call(description.children);

    for (var i = 0; i < children.length; i++) {
      if (isSplitHeading(children[i])) {
        return children[i];
      }
    }

    return null;
  }

  function initDescriptionReadMore() {
    var descriptions = document.querySelectorAll(DESCRIPTION_SELECTOR);

    descriptions.forEach(function (description) {
      if (description.dataset.croReadMoreInitialized === 'true') {
        return;
      }

      var splitNode = findSplitNode(description);

      if (!splitNode) {
        return;
      }

      description.dataset.croReadMoreInitialized = 'true';

      var extra = document.createElement('div');
      extra.className = 'cro-description-extra';

      while (splitNode) {
        var nextNode = splitNode.nextSibling;
        extra.appendChild(splitNode);
        splitNode = nextNode;
      }

      var fade = document.createElement('div');
      fade.className = 'cro-description-fade';

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'cro-description-toggle';
      toggle.textContent = 'Read More';
      toggle.setAttribute('aria-expanded', 'false');

      description.appendChild(fade);
      description.appendChild(toggle);
      description.appendChild(extra);

      toggle.addEventListener('click', function () {
        var isExpanded = extra.classList.toggle('is-expanded');

        toggle.textContent = isExpanded ? 'Show Less' : 'Read More';
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        fade.classList.toggle('is-hidden', isExpanded);

        if (!isExpanded) {
          description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionReadMore);
  } else {
    initDescriptionReadMore();
  }

  document.addEventListener('shopify:section:load', initDescriptionReadMore);
})();
(function () {
  function initBottomShowLess() {
    var description = document.querySelector('.product-block-list__item--description .card__section .rte');

    if (!description) return;

    /* Find the existing Read More / Show Less trigger that already works */
    var topToggle = Array.from(description.querySelectorAll('button, a')).find(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      return text === 'read more' || text === 'show less';
    });

    if (!topToggle) return;

    /* Prevent duplicate bottom buttons */
    if (description.querySelector('.fbg-description-bottom-toggle')) return;

    var bottomToggle = document.createElement('button');
    bottomToggle.type = 'button';
    bottomToggle.className = 'fbg-description-bottom-toggle';
    bottomToggle.textContent = 'Show Less';
    bottomToggle.setAttribute('aria-label', 'Show less product description');

    description.appendChild(bottomToggle);

    function syncBottomToggle() {
      var topText = (topToggle.textContent || '').trim().toLowerCase();
      var isExpanded = topText === 'show less';
      bottomToggle.classList.toggle('is-visible', isExpanded);
    }

    bottomToggle.addEventListener('click', function () {
      topToggle.click();

      setTimeout(function () {
        topToggle.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 50);
    });

    topToggle.addEventListener('click', function () {
      setTimeout(syncBottomToggle, 50);
    });

    syncBottomToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBottomShowLess);
  } else {
    initBottomShowLess();
  }
})();
(function () {
  function initFbgFloatingCta() {
    /* Product pages only */
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    var mainButton = productForm.querySelector('[type="submit"], button[name="add"]');
    if (!mainButton) return;

    /* Prevent duplicates */
    if (document.querySelector('.fbg-floating-cta')) return;

    var floatingCta = document.createElement('div');
    floatingCta.className = 'fbg-floating-cta';
    floatingCta.setAttribute('aria-hidden', 'true');

    var priceEl = document.createElement('div');
    priceEl.className = 'fbg-floating-cta__price';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fbg-floating-cta__button';

    floatingCta.appendChild(priceEl);
    floatingCta.appendChild(button);
    document.body.appendChild(floatingCta);

  function findCurrentPriceText() {
  function cleanPriceText(el) {
    if (!el || !el.textContent) {
      return '';
    }

    var priceText = el.textContent.trim().replace(/\s+/g, ' ');
    priceText = priceText.replace(/sale price/ig, '').replace(/regular price/ig, '').trim();

    var priceMatch = priceText.match(/\$\s?\d[\d,]*(?:\.\d{2})?/);
    return priceMatch ? priceMatch[0].replace(/\s+/g, '') : priceText;
  }

  var selectors = [
    '.product-form__info-list--cro-price .price--cro-sale',
    '.product-form__info-list--cro-price .price--highlight',
    '.price-list--cro .price--cro-sale',
    '.price-list--cro .price--highlight',
    '.product-meta__price-list .price--highlight',
    '.product-meta__price-list .price--sale',
    '[data-product-price]',
    'span.price[data-sezzleindex="0"]',
    '.product-meta__price-list .price',
    '.product__price',
    '.product-price'
  ];

  for (var i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    var cleanedPrice = cleanPriceText(el);

    if (cleanedPrice) {
      return cleanedPrice;
    }
  }

  return '';
}


    function getMainButtonText() {
      var text = (mainButton.textContent || '').trim().replace(/\s+/g, ' ');
      return text || 'Add to Cart';
    }

    function syncFloatingCta() {
      var price = findCurrentPriceText();
      priceEl.textContent = price;
      priceEl.style.display = price ? 'block' : 'none';

      button.textContent = getMainButtonText();

      var isDisabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      button.disabled = isDisabled;
      button.classList.toggle('is-disabled', isDisabled);
    }

    button.addEventListener('click', function () {
      syncFloatingCta();

      if (button.disabled) return;

      /* Use the existing product form/button so selected variant and quantity are preserved */
      mainButton.click();
    });

    function showFloatingCta() {
      floatingCta.classList.add('is-visible');
      floatingCta.setAttribute('aria-hidden', 'false');
    }

    function hideFloatingCta() {
      floatingCta.classList.remove('is-visible');
      floatingCta.setAttribute('aria-hidden', 'true');
    }

    function updateFloatingCtaVisibility() {
  var rect = mainButton.getBoundingClientRect();

  if (rect.bottom <= 0) {
    showFloatingCta();
    syncFloatingCta();
  } else {
    hideFloatingCta();
  }
}

hideFloatingCta();

window.addEventListener('scroll', updateFloatingCtaVisibility, { passive: true });
window.addEventListener('resize', updateFloatingCtaVisibility);

/* Sync after variant/quantity changes */
productForm.addEventListener('change', function () {
  setTimeout(function () {
    syncFloatingCta();
    updateFloatingCtaVisibility();
  }, 100);
});

document.addEventListener('click', function () {
  setTimeout(function () {
    syncFloatingCta();
    updateFloatingCtaVisibility();
  }, 150);
});

updateFloatingCtaVisibility();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFbgFloatingCta);
} else {
  initFbgFloatingCta();
}
})();
